import styles from './BoxItem.module.css'

function BoxItem({
                     borderColor,
                     label,
                     value,
                     corner,
                 }) {
    return (
        <div
            className={styles.card}
            style={{
                borderBottom: `4px solid ${borderColor}`,
                flex: '1 1 0px',
            }}
        >
            <div className={styles.cardBody}>
                {/* label row */}
                <div className={styles.labelRow}>
                    <div className={styles.labelText}>{label}</div>
                    {corner && <div>{corner}</div>}
                </div>

                {/* value row */}
                <div className="align-items-center d-flex gap-3 mt-2">
                    {value}
                </div>
            </div>
        </div>
    )
}

export default BoxItem
